import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { Spinner } from '@dd/ui';
import { onUnauthenticated } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { Shell } from '@/components/Shell';
import { Login } from '@/pages/Login';
import { Overview } from '@/pages/Overview';
import { Accounts } from '@/pages/Accounts';
import { AccountDetail } from '@/pages/AccountDetail';
import { Billing } from '@/pages/Billing';
import { ManualPayments } from '@/pages/ManualPayments';
import { Settings } from '@/pages/Settings';
import { Tickets } from '@/pages/Tickets';
import { TicketDetail } from '@/pages/TicketDetail';
import { Governance } from '@/pages/Governance';
import { Content } from '@/pages/Content';
import { System } from '@/pages/System';
import { AuditLog } from '@/pages/AuditLog';
import { Admins } from '@/pages/Admins';
import { AdminEditor } from '@/pages/AdminEditor';

export function App() {
  const phase = useAuth((s) => s.phase);
  useEffect(() => { void useAuth.getState().boot(); return onUnauthenticated(() => useAuth.getState().expire()); }, []);
  if (phase === 'boot') return <div className="flex min-h-dvh items-center justify-center"><Spinner size={28} /></div>;
  if (phase === 'out') return <Login />;
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Shell />}>
          <Route index element={<Overview />} />
          <Route path="accounts" element={<Accounts />} />
          <Route path="accounts/:id" element={<AccountDetail />} />
          <Route path="billing" element={<Billing />} />
          <Route path="payments-verify" element={<ManualPayments />} />
          <Route path="settings" element={<Settings />} />
          <Route path="tickets" element={<Tickets />} />
          <Route path="tickets/:id" element={<TicketDetail />} />
          <Route path="governance" element={<Governance />} />
          <Route path="content" element={<Content />} />
          <Route path="system" element={<System />} />
          <Route path="audit" element={<AuditLog />} />
          <Route path="admins" element={<Admins />} />
          <Route path="admins/new" element={<AdminEditor />} />
          <Route path="admins/:id" element={<AdminEditor />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
